// extracted by mini-css-extract-plugin
export default {"message":"styles_message__blSh6","message_text":"styles_message_text__9yL-i","message_icon":"styles_message_icon__fbVsJ"};